<div class="flex h-full flex-col justify-center gap-2 px-4 py-3">
  <div class="flex items-center justify-between gap-3">
    <p class="text-xs font-semibold text-slate-500 uppercase tracking-wide leading-tight">Pendiente por cobrar</p>
    <span class="shrink-0 flex items-center justify-center w-9 h-9 rounded-xl bg-amber-100">
      <i class="pi pi-hourglass text-amber-600 text-base"></i>
    </span>
  </div>
  <p class="text-3xl font-bold text-amber-600 leading-none tabular-nums">
    {{ formatCurrency(data()?.rates?.totalPending ?? 0) }}
  </p>
  <p class="text-xs text-slate-500 font-medium">
    Sobre facturas del período
  </p>
</div>
